import { ChangeEvent, FC, useCallback, useEffect, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useSearchParams } from "react-router-dom";
import { CostAllocationTagsDrawerBody } from "./CostAllocationTagsDrawerBody";

export const collapseCostAllocationTagsSearchParam =
  "collapseCostAllocationTagsSearchParam";

export const VewTagsSelect: FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [search, setSearch] = useState("");
  const [needToScrollInToView, setNeedToScrollInToView] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const searchChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setSearch(e.target.value);
    },
    [],
  );

  const collapseHandler = useCallback(() => setCollapsed((c) => !c), []);

  useEffect(() => {
    const collapseTags =
      searchParams.get(collapseCostAllocationTagsSearchParam) ?? "";

    if (collapseTags) {
      setCollapsed(true);

      searchParams.delete(collapseCostAllocationTagsSearchParam);
      setSearchParams(searchParams);
      setNeedToScrollInToView(true);
    }
  }, [searchParams, setSearchParams]);

  return (
    <Box border={1} borderRadius={1} p={1} borderColor="grey.400">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        onClick={collapseHandler}
        sx={{ cursor: "pointer" }}
      >
        <Typography variant="body2" fontWeight="medium">
          AWS Cost Allocation Tags
        </Typography>

        <IconButton size="small">
          {collapsed ? (
            <ArrowDropUpIcon fontSize="small" sx={{ color: "action" }} />
          ) : (
            <ArrowDropDownIcon fontSize="small" sx={{ color: "action" }} />
          )}
        </IconButton>
      </Stack>

      <Collapse in={collapsed}>
        <Stack spacing={1} maxHeight={400} pt={1}>
          <TextField
            fullWidth
            size="small"
            onChange={searchChangeHandler}
            placeholder="Search by tag key"
            InputProps={inputProps}
          />

          <CostAllocationTagsDrawerBody
            provider="aws"
            searchValue={search}
            needToScrollInToView={needToScrollInToView}
            setNeedToScrollInToView={setNeedToScrollInToView}
          />
        </Stack>
      </Collapse>
    </Box>
  );
};

const inputProps = {
  startAdornment: (
    <InputAdornment position="start">
      <SearchIcon />
    </InputAdornment>
  ),
};
